<template>
  <b-card v-if="visible" class="mt-0">
    <div
      class="header-tabs d-flex align-items-center justify-content-between mb-3"
    >
      <h5 class="mb-0">{{ title }}</h5>

      <div class="btn-group" role="group">
        <template v-for="option in filterOptions">
          <b-button
            v-if="!((title.includes('Fora de data') || title.includes('Estabelecimentos')))"

            :key="title + '-' + option.value"
            size="sm"
            :variant="
              currentFilter === option.value ? 'primary' : 'outline-primary'
            "
            @click="setFilter(option.value)"
          >
            {{ option.label }}
          </b-button>
        </template>
      </div>
    </div>

   <div v-if="filteredData.length === 0" class="text-center text-danger my-4">
  {{ title.includes("Estabelecimentos") ? "Nenhum registro encontrado" : "Nenhuma transação encontrada" }}
</div>

<div v-else class="table-scroll">
  <b-table
    :items="filteredData"
    :fields="fields"
    :per-page="perPage"
    :current-page="page"
    bordered
    hover
    small
    @row-clicked="handleRowClick"
  >
        <template #cell(value)="data">
          <span
            v-if="
              data.item.label &&
              (data.item.label.includes('Qtd') ||
                data.item.label.includes('Quantidade'))
            "
          >
            {{ formatNumber(data.item.value) }}
          </span>
          <span v-else>
            {{ formatCurrency(data.item.value) }}
          </span>
        </template>

        <template #cell(devolution_amount)="data">
          {{ formatCurrency(data.item.devolution_amount) }}
        </template>

        <template #cell(gross_amount)="data">
          {{ formatCurrency(data.item.gross_amount) }}
        </template>

      <template #cell(transaction_date)="data">
        {{ new Date(data.item.transaction_date).toLocaleDateString("pt-BR", { timeZone: "UTC" }) }}
      </template>

        <template #cell(file_date)="data">
          {{ new Date(data.item.file_date).toLocaleDateString("pt-BR", { timeZone: "UTC" }) }}
        </template>
       <template #cell(date)="data">
        {{ data.item.date ? new Date(data.item.date).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : "-" }}
      </template>
          <template #cell(itau)="data">
        {{ formatIfCurrency(data.item.itau, data.item.label) }}
        </template>

        <template #cell(veripag)="data">
          {{ formatIfCurrency(data.item.veripag, data.item.label) }}
        </template>

        <template #cell(gsurf)="data">
          {{ formatIfCurrency(data.item.gsurf, data.item.label) }}
        </template>
      </b-table>
    </div>

    <b-pagination
      v-model="page"
      :total-rows="filteredData ? filteredData.length : 0"
      :per-page="perPage"
      align="center"
      size="sm"
      class="my-2"
    />
  </b-card>
</template>

<script>
import { BCard, BTable, BButton, BPagination } from "bootstrap-vue";

export default {
  components: { BCard, BTable, BButton, BPagination },

  props: {
    title: String,
    tableData: Array,
    visible: Boolean,
  },

  data() {
    return {
      currentFilter: "all",
      page: 1,
      perPage: 10,
    };
  },

  computed: {
    isPixTable() {
      return this.title?.toUpperCase().includes("PIX");
    },
    filterOptions() {
      if (this.isPixTable) {
        return [
          { label: "Resumo", value: "all" },
          { label: "Veripag", value: "veripag" },
          { label: "Itaú", value: "itau" },
          { label: "Gsurf", value: "gsurf" },
        ];
      }

      return [
        { label: "Resumo", value: "all" },
        { label: "Transações", value: "notConciliate" },
      ];
    }, 

    fields() {

      if (this.title === "PIX" && this.currentFilter === "all") {
      return [
        { key: "label", label: "Descrição" },
        { key: "itau", label: "Itaú" },
        { key: "veripag", label: "Veripag" },
        { key: "gsurf", label: "Gsurf" },
      ];
    }
      if (!this.title || typeof this.title !== "string") {
        return [
          { key: "label", label: "Descrição" },
          { key: "value", label: "Valor" },
        ];
      }

      if (this.title.includes("Estabelecimentos")) {
        return [
          { key: "date", label: "Data" },
          { key: "register", label: "Registro" },
          { key: "ec", label: "EC" },
          { key: "establishment", label: "Estabelecimento" },
          { key: "affiliation", label: "Afiliação" },
        ];
      }

      if (this.title.includes("Fora de data")) {
        return [
          { key: "nsu", label: "NSU" },
          { key: "transaction_date", label: "Data Transação" },
          { key: "file_date", label: "Data Arquivo" },
          { key: "is_conciliated", label: "Conciliado" },
          { key: "gross_amount", label: "Valor" },
        ];
      }
      if (
        this.title.includes("Outros status") &&
        this.filteredData.length &&
        !this.filteredData[0].label
      ) {

        const baseFields = [
          { key: "nsu", label: "NSU" },
          { key: "transaction_date", label: "Data" },
        ];

        const hasStatus = this.filteredData.some(item => item.status);
        if (hasStatus) {
          baseFields.push({ key: "status", label: "Status" });
        }

        const hasBrand = this.filteredData.some(item => item.brand);
        if (hasBrand) {
          baseFields.push({ key: "brand", label: "Bandeira" });
        }

        baseFields.push({ key: "gross_amount", label: "Valor" });

        return baseFields;
      }

      if (this.title.includes("PIX - Veripag - Não Conciliados") ) {
        return [
          { key: "nsu", label: "NSU" },
          { key: "transaction_date", label: "Data" },
          { key: "gross_amount", label: "Valor" },
          { key: "ec", label: "EC" },
          { key: "platform_type", label: "Plataforma" },
          { key: "installment_quantity", label: "Qtde. Parcelas" },
          { key: "brand", label: "Bandeira" },
          { key: "status", label: "Status" },
          { key: "tid", label: "TID" },
        ];
      }

      if (this.title.includes("PIX - GSurf - Não Conciliados") ) {
        return [
          { key: "nsu", label: "NSU" },
          { key: "transaction_date", label: "Data" },
          { key: "gross_amount", label: "Valor" },
          { key: "status", label: "Status" },
          { key: "tid", label: "TID" },
        ];
      }

      if (this.title.includes("PIX - Itaú - Não Conciliados") ) {
        return [
          { key: "devolution_amount", label: "Valor da Devolução" },
          { key: "transaction_date", label: "Data" },
          { key: "gross_amount", label: "Valor" },
          { key: "tid", label: "TID" },
        ];
      }

      if (this.title.includes("Não Conciliados")) {
        const baseFields = [
          { key: "nsu", label: "NSU" },
          { key: "transaction_date", label: "Data" },
        ];

        const hasStatus = this.filteredData.some((item) => item.status);
        if (hasStatus) {
          baseFields.push({ key: "status", label: "Status" });
        }

        const hasBrand = this.filteredData.some((item) => item.brand);
        if (hasBrand) {
          baseFields.push({ key: "brand", label: "Bandeira" });
        }

        baseFields.push({ key: "gross_amount", label: "Valor" });

        return baseFields;
      }

      if (this.title.includes("Processando - Transações")) {
        const baseFields = [
          { key: "transaction_date", label: "Data" },
          { key: "nsu", label: "NSU" },
          { key: "gross_amount", label: "Valor" },
        ];

        const hasStatus = this.filteredData.some((item) => item.status);
        if (hasStatus) {
          baseFields.push({ key: "status", label: "Status" });
        }

        const hasBrand = this.filteredData.some((item) => item.brand);
        if (hasBrand) {
          baseFields.push({ key: "brand", label: "Bandeira" });
        }

        baseFields.push(
          { key: "installment_quantity", label: "Qtd Parcelas" },
          { key: "installment_number", label: "Parcela Atual" }
        );

        return baseFields;
      }

      return [
        { key: "label", label: "Descrição" },
        { key: "value", label: "Valor" },
      ];
    },

    filteredData() {
      return Array.isArray(this.tableData) ? this.tableData : [];
    },
  },

  methods: {
    formatIfCurrency(value, label) {
      if (label.includes('Qtd') || label.includes('Quantidade')) {
        return value 
      }
      return this.formatCurrency(value)
    },
   setFilter(value) {
  this.currentFilter = value;

  if (value === "all") {
    this.$emit("back-to-resume");
    return;
  }

  if (this.isPixTable) {
    if (value === "veripag") {
      this.$emit("open-not-conciliated", "PIX - Veripag - Não Conciliados");
    } else if (value === "itau") {
      this.$emit("open-not-conciliated", "PIX - Itaú - Não Conciliados");
    } else if (value === "gsurf") {
      this.$emit("open-not-conciliated", "PIX - GSurf - Não Conciliados");
    }
    return;
  }

  if (value === "notConciliate") {
    this.$emit("open-not-conciliated", this.title);
  }
},

    resetFilter() {
      this.currentFilter = "all";
      this.page = 1;
    },

    formatCurrency(value) {
      if (typeof value !== "number") return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },

    formatNumber(value) {
      if (value === null || value === undefined) return 0;
      return Number(value);
    },

    handleRowClick(item) {
      if (this.currentFilter !== "notConciliate") return;
      if (!this.title.includes("Veripag - Não Conciliados")) return;
      this.$emit("row-selected", item);
    },
  },
};
</script>

<style scoped>
h5 {
  font-weight: 600;
}

.header-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-group .btn {
  margin-left: 6px;
  transition: all 0.2s ease;
}

.btn-group .btn:hover {
  transform: scale(1.05);
}
.table-scroll {
  width: 100%;
  overflow-x: auto;
}
</style>
